import { registerRemotes } from '@module-federation/enhanced/runtime';

const RUNTIME_REMOTES = [
  { name: 'shipbob_design_system', settingKey: 'SHIPBOB_DESIGN_SYSTEM', required: true },
  { name: 'shipbob_mfe_runtime',   settingKey: 'SHIPBOB_MFE_RUNTIME',   required: true },
];

/** Register all runtime remotes from app settings; returns false if any required URL is missing. */
export function registerRuntimeRemotes(appSettings) {
  const settings = appSettings || {};
  const missingRequired = [];

  RUNTIME_REMOTES.forEach(({ name, settingKey, required }) => {
    const value = settings[settingKey];
    if (typeof value !== 'string' || !value.trim()) {
      if (required) missingRequired.push(settingKey);
      else console.error(`[downloads-ui] ${settingKey} missing; skipping ${name} remote`);
      return;
    }
    const trimmed = value.trim().replace(/\/$/, '');
    let parsed;
    try {
      parsed = new URL(trimmed);
    } catch {
      if (required) missingRequired.push(settingKey);
      console.error(`[downloads-ui] ${settingKey} is not a valid URL; skipping ${name} remote`);
      return;
    }
    if (!['https:', 'http:'].includes(parsed.protocol) || parsed.username || parsed.password) {
      if (required) missingRequired.push(settingKey);
      console.error(
        `[downloads-ui] ${settingKey} must be an http(s) URL without credentials; skipping ${name} remote`,
      );
      return;
    }
    registerRemotes([{ name, entry: `${trimmed}/remoteEntry.js` }], { force: true });
  });

  if (missingRequired.length) {
    console.error(`[downloads-ui] missing required runtime remote settings: ${missingRequired.join(', ')}`);
  }

  return missingRequired.length === 0;
}
